<button mat-fab [color]="!isMinorista?'accent':'primary'" type="button" aria-label="Consulta precio" [matTooltip]="'Consultar Precios'" matTooltipPosition="left" class="consulta-precio"
        *ngIf="mostrar" [routerLink]="['usuario','consultaPrecios']">
  <mat-icon color="accent" style="color: white; font-size: 18px;"><i class="fas fa-cash-register"></i></mat-icon>
</button>

